import React, { useState } from 'react';
import { post } from '../utils/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Reset Password</h1>
        {sent ? (
          <>
            <p style={{color:'#065F46', backgroundColor:'#ECFDF5', padding:'12px', borderRadius:'6px', fontSize:'14px'}}>
              If that email address is registered, you'll receive a password reset link shortly. Please check your inbox.
            </p>
            <a href="/login" className="btn btn-secondary" style={{display:'inline-block', marginTop:'16px', textDecoration:'none', textAlign:'center'}}>
              Back to Sign In
            </a>
          </>
        ) : (
          <>
            <p style={{color:'#6B7280', fontSize:'14px', marginBottom:'20px'}}>
              Enter your email address and we'll send you a link to reset your password.
            </p>
            {error && <div className="form-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@mediationinstitute.edu.au"
                  required
                />
              </div>
              <button className="btn btn-primary" type="submit" disabled={loading} style={{width:'100%'}}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            <div style={{textAlign:'center', marginTop:'16px'}}>
              <a href="/login" style={{color:'#2563EB', fontSize:'14px', textDecoration:'none'}}>
                Back to Sign In
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
